module.exports = __webpack_public_path__ + "static/media/404-image.76be7cd0.jpg";